var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "m10 4-8 7.79L10 20l1.5-1.5L6 13h16v-2H6l5.5-5.5z"
  })));
};
export { SvgBackArrow as Icon };
export default __webpack_public_path__ + "static/media/44ecad71c302a743d35de7881ce89c17.svg";